import { FC, PropsWithChildren } from "react";

import { FixaFormField } from "@coworker/apprestructured/src/shared/wrappers/FixaFormField/FixaFormField";
import styles from "./InputWrapper.module.css";

interface InputValidationWrapperProps extends PropsWithChildren {
  error?: string | null;
}

const InputWrapper: FC<InputValidationWrapperProps> = ({ error, children }) => {
  return (
    <FixaFormField
      className={styles["root"]!}
      validation={{ msg: error || "", type: "error" }}
      valid={!error}
      shouldValidate={!!error}
    >
      {children}
    </FixaFormField>
  );
};

export default InputWrapper;
